import { lambdaErrorCheck } from "../../../common/util/errorHandling";
import { useAppSelector } from "../../../store";
import { useGetGroupManagementOverviewQuery } from "../../../services/GroupManagementOverview/groupManagementOverviewAPI";
import type { GroupManagementOverviewResponse } from "../../../services/GroupManagementOverview/groupManagementOverviewAPI.types";

export const defaultOverviewData = (): GroupManagementOverviewResponse => ({
  NavigationItems: [],
  ActionReportItems: [],
  Error: [],
});

export const useGroupManagementOverview = () => {
  const { user } = useAppSelector((state) => state.boot);

  const {
    data: payloadData,
    isFetching,
    isError,
    refetch,
  } = useGetGroupManagementOverviewQuery({
    abo: user.abo,
    aff: user.aff,
  });

  const isLoading = isFetching && !payloadData;

  const groupManagementOverviewData = payloadData ?? defaultOverviewData();

  const errorStatus = isError || (payloadData ? lambdaErrorCheck(payloadData.Error) : false);

  return { isLoading, groupManagementOverviewData, errorStatus, refetch };
};
